<div style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; height: 100%">
  @if (!loading) {
    <mat-horizontal-stepper linear #stepper class="welcome-stepper">
      <mat-step label="Welcome">
        <h1>Welcome, {{user.userName + ' ' + user.userLastName}}</h1>
        <div style="margin-top: 10px; display: flex; justify-content: space-between;">
          <button mat-raised-button matStepperNext color="primary">NEXT</button>
        </div>
      </mat-step>
      <mat-step label="Photo" >
        <h3 style="margin-top: 30px; text-align: center;">You can change your photo here</h3>
        <div style="display: flex; justify-content: center; align-items: center; flex-direction: column;">
          <div style="display: flex; justify-content: center;">
            <div [ngClass]="'person' + imageIndexList[0]"></div>
          </div>
          <input #file type="file" style="display: none">
          <button mat-raised-button (click)="file.click() " color="primary" style="margin-top: 10px;">SELECT PHOTO</button>
        </div>
        <div style="margin-top: 10px; display: flex; justify-content: space-between;">
          <button mat-raised-button matStepperPrevious color="primary">BACK</button>
          <button mat-raised-button matStepperNext color="primary" style="margin-left: 10px;">NEXT</button>
        </div>
      </mat-step>
      <mat-step label="Meet your managers">
        <h3 style="margin-top: 30px">Meet your managers</h3>
        <div style="display: flex;">
          @for (manager of managers; track manager; let i = $index) {
            <mat-card style="margin: 10px">
              <mat-card-title>{{manager.userName + ' ' + manager.userLastName}}</mat-card-title>
              <mat-card-content>
                <div style="display: flex; justify-content: center;">
                  @if (manager.hasPhoto) {
                    <img [src]="'/public/getUserPhoto/' + manager.userId">
                  }
                  @if (!manager.hasPhoto) {
                    <div [ngClass]="'person' + imageIndexList[i]"></div>
                  }
                </div>
                <mat-list>
                  <mat-list-item>
                    <mat-icon matListItemIcon>email</mat-icon>
                    <a mat-line href="mailto: {{manager.userEmail}}">{{manager.userEmail}}</a>
                  </mat-list-item>
                  <mat-list-item>
                    <mat-icon matListItemIcon>phone</mat-icon>
                    <a mat-line href="tel:{{manager.userPhoneNumber}}">{{manager.userPhoneNumber}}</a>
                  </mat-list-item>
                  <mat-list-item>
                    <mat-icon matListItemIcon>forum</mat-icon>
                    <div mat-line>Chat</div>
                  </mat-list-item>
                </mat-list>
              </mat-card-content>
            </mat-card>
          }
        </div>
        <div style="margin-top: 10px; display: flex; justify-content: space-between;">
          <button mat-raised-button matStepperPrevious color="primary">BACK</button>
          <button mat-raised-button matStepperNext color="primary" style="margin-left: 10px;">NEXT</button>
        </div>
      </mat-step>
      <mat-step label="Cookie">
        <div> We use cookie  at the site.
          <mat-checkbox [(ngModel)]="checked"> I understand </mat-checkbox>
        </div>
        <div style="margin-top: 10px; display: flex; justify-content: space-between;">
          <button mat-raised-button matStepperPrevious color="primary">BACK</button>
          <button mat-raised-button (click)="onAcceptCookieClick()" [disabled]="!checked" color="primary" style="margin-left: 10px;">NEXT</button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  }
  <!--<div style="display: none;">
  <h1>Welcome, {{user.userName + ' ' + user.userLastName}}</h1>
  <h3 style="margin-top: 30px">You can change your photo here</h3>
  <div style="display: flex; justify-content: center; align-items: center">
    <div style="display: flex; justify-content: center;">
      <div [ngClass]="'person' + imageIndexList[0]"></div>
    </div>
    <input #file type="file" style="display: none">
    <button mat-raised-button (click)="file.select()" color="primary">SELECT PHOTO</button>
  </div>
  <h3 style="margin-top: 30px">Meet your managers</h3>
  <div style="display: flex;">
    <mat-card *ngFor="let manager of managers; let i = index" style="margin: 10px">
      <mat-card-title>{{manager.userName + ' ' + manager.userLastName}}</mat-card-title>
      <mat-card-content>
        <div style="display: flex; justify-content: center;">
          <img [src]="'/public/getUserPhoto/' + manager.userId" *ngIf="manager.hasPhoto">
          <div [ngClass]="'person' + imageIndexList[i]" *ngIf="!manager.hasPhoto"></div>
        </div>
        <mat-list>
          <mat-list-item>
            <mat-icon matListItemIcon>email</mat-icon>
            <a mat-line href="mailto: {{manager.userEmail}}">{{manager.userEmail}}</a>
          </mat-list-item>
          <mat-list-item>
            <mat-icon matListItemIcon>phone</mat-icon>
            <a mat-line href="tel:{{manager.userPhoneNumber}}">{{manager.userPhoneNumber}}</a>
          </mat-list-item>
          <mat-list-item>
            <mat-icon matListItemIcon>forum</mat-icon>
            <div mat-line>Chat</div>
          </mat-list-item>
        </mat-list>
      </mat-card-content>
    </mat-card>
  </div>
  <div> We use cookie  at the site.
    <mat-checkbox [(ngModel)]="checked"> I understand </mat-checkbox>
  </div>
  <div>
    <button mat-raised-button (click)="onAcceptCookieClick()" [disabled]="!checked" color="primary">NEXT</button>
  </div>
</div>-->
@if (loading) {
  <mat-spinner></mat-spinner>
}
</div>
